exports.components = {
  "component---src-pages-editor-js": () => import("./../../../src/pages/editor.js" /* webpackChunkName: "component---src-pages-editor-js" */),
  "component---src-templates-storyblok-page-js": () => import("./../../../src/templates/storyblok-page.js" /* webpackChunkName: "component---src-templates-storyblok-page-js" */)
}

